import { VIVACE_HOSTNAME, EXP_HOSTNAME } from "@ane/core/lib/host/Host.constants";
const HELP_PAGE = "https://aka.ms/exp/help";
const ICM_URL = "http://aka.ms/exp/icm";
const ALERT_HELP_PAGE = "https://aka.ms/exp/alerts";
const AUTO_SHUTDOWN_HELP = "http://aka.ms/exp/Experiment/AutomaticExperimentShutdown";
const ANALYSIS_TEMPLATES_HELP = "https://aka.ms/exp/analysistemplates";
const EXP_WIKI = "https://aka.ms/exp/docs";
const AZURE_EXP_WIKI = "https://aka.ms/exp/docs";
const AZURE_EXP_WIKI_FEATURE_EXPERIMENTS = "https://aka.ms/exp/studio/featureexperiment";
const TRIGGER_FILTER_HELP = "https://eng.ms/cid/a6c59aee-2231-4b16-9763-2281d173a4fa/fid/ed144e14bb288cca704dd26bc4eae3a623298737d62e703d066ad887095e5579";
const WHERE_CLAUSE_HELP = "https://dev.azure.com/experimentation/Analysis%20and%20Experimentation/_wiki/wikis/AnE.wiki/1043/Where-Clause-Examples";
const SIDE_STREAM_HELP = "https://aka.ms/exp/analysis/sidestream";
const FEATURE_COMPOSITION_INFO = "http://aka.ms/exp/featurecomposition";
const VERTICAL_LIST = "http://aka.ms/exp/VerticalList";
const EXP_FEEDBACK_MAILTO = "mailto:expuxfeed@microsoft.com";
const EXP_PRIVACY_POLICY = "http://go.microsoft.com/fwlink/?LinkId=518021";
const VIVACE_DOMAIN = `https://${VIVACE_HOSTNAME}`;
const VIVACE_SUBPATH = `https://${EXP_HOSTNAME}/vivace/`;
const VIVACE_IFRAME_SUBPATH = `https://${EXP_HOSTNAME}/metric-set`;
const XCARD_DOMAIN = "https://exp.microsoft.com/xcard/";
const XCARD_PPE = "https://xcard-ui-mvc-preprod-cus.azurewebsites.net/xcard/";
const STUDIO_SUPPORT = "https://aka.ms/exp/studio/support";
const WORKSPACE_SELECTION_HELP = "https://aka.ms/exp/workspaceselection";
const STUDIO_FEEDBACK = "https://aka.ms/exp/studiofeedback";
const GAR_TRUSTWORTHINESS = "https://aka.ms/exp/gar/trustworthiness";
const ALERT_CONFIGURATION = "https://expdocs.azurewebsites.net/docs/metricauth/createmetricalerts.html";
const ISOLATION_GROUPS_DOCS = "https://eng.ms/docs/products/experimentation-platform/docs/assignment/isolationgroupsmanagement";
const TRIGGERED_ANALYSIS_WIKI = "https://eng.ms/docs/products/experimentation-platform/docs/analysis/triggeredscorecardsacrosssteps";
const TRIGGERED_ANALYSIS_WIKI_NEW = "https://eng.ms/docs/products/experimentation-platform/docs/analysis/triggeredscorecardsacrossstepsnew";
const FIND_WORKSPACE_ACCESS_INSTRUCTIONS = "https://aka.ms/exp/workspaceaccess";
export {
  ALERT_CONFIGURATION,
  ALERT_HELP_PAGE,
  ANALYSIS_TEMPLATES_HELP,
  AUTO_SHUTDOWN_HELP,
  AZURE_EXP_WIKI,
  AZURE_EXP_WIKI_FEATURE_EXPERIMENTS,
  EXP_FEEDBACK_MAILTO,
  EXP_PRIVACY_POLICY,
  EXP_WIKI,
  FEATURE_COMPOSITION_INFO,
  FIND_WORKSPACE_ACCESS_INSTRUCTIONS,
  GAR_TRUSTWORTHINESS,
  HELP_PAGE,
  ICM_URL,
  ISOLATION_GROUPS_DOCS,
  SIDE_STREAM_HELP,
  STUDIO_FEEDBACK,
  STUDIO_SUPPORT,
  TRIGGERED_ANALYSIS_WIKI,
  TRIGGERED_ANALYSIS_WIKI_NEW,
  TRIGGER_FILTER_HELP,
  VERTICAL_LIST,
  VIVACE_DOMAIN,
  VIVACE_IFRAME_SUBPATH,
  VIVACE_SUBPATH,
  WHERE_CLAUSE_HELP,
  WORKSPACE_SELECTION_HELP,
  XCARD_DOMAIN,
  XCARD_PPE
};
//# sourceMappingURL=LinkConstants.js.map
